import { render } from "react-dom";
import App from "./App";
import "bulma/css/bulma.css";

render(<App />, document.querySelector("#content"));